import {
  ModuleIOValueTypeEnum,
  ModuleInputKeyEnum,
  ModuleOutputKeyEnum,
  ModuleTemplateTypeEnum,
} from '../../constants';
import {
  FlowNodeInputTypeEnum,
  FlowNodeOutputTypeEnum,
  FlowNodeTypeEnum,
} from '../../node/constants';
import { FlowModuleTemplateType } from '../../types';
import {
  Input_Template_AiModel,
  Input_Template_Dataset_Quote,
  Input_Template_History,
  Input_Template_Switch,
  Input_Template_System_Prompt,
  Input_Template_UserChatInput,
} from '../input';
import { Output_Template_Finish } from '../output';

export const AiChatModule: FlowModuleTemplateType = {
  id: FlowNodeTypeEnum.aiChat,
  templateType: ModuleTemplateTypeEnum.logicDeal,
  flowType: FlowNodeTypeEnum.aiChat,
  avatar: '/imgs/module/AI.png',
  name: 'AI 对话',
  description: 'AI 大模型对话',
  inputs: [
    Input_Template_Switch,
    Input_Template_AiModel,
    {
      key: ModuleInputKeyEnum.aiChatTemperature,
      type: FlowNodeInputTypeEnum.numberInput,
      label: '回答随机性',
      value: 0,
      valueType: ModuleIOValueTypeEnum.number,
      min: 0,
      max: 10,
      step: 1,
      showTargetInApp: false,
      showTargetInPlugin: false,
      description: 'AI回答的随机性',
      required: true,
    },
    {
      key: ModuleInputKeyEnum.aiChatMaxToken,
      type: FlowNodeInputTypeEnum.numberInput, // Set in the pop-up window
      label: '回复上限',
      description: '回复内容最大的长度',
      value: 2000,
      valueType: ModuleIOValueTypeEnum.number,
      min: 100,
      max: 4000,
      step: 50,
      showTargetInApp: false,
      showTargetInPlugin: false,
      required: true,
    },
    {
      ...Input_Template_System_Prompt,
      label: '提示词',
      description: '引导模型进行输出的提示词',
      placeholder:
        '模型固定的引导词，通过调整该内容，可以引导模型聊天方向。该内容会被固定在上下文的开头。可使用变量，例如 {{language}}',
      required: true,
      showTargetInApp: true,
      showTargetInPlugin: true,
    },
    Input_Template_Dataset_Quote,
    Input_Template_History,
    {
      ...Input_Template_UserChatInput,
      toolDescription: '用户输入',
      description: '用户最新的一条输入',
    },
  ],
  outputs: [
    Output_Template_Finish,
    {
      key: ModuleOutputKeyEnum.aiAnswer,
      label: 'AI回复内容',
      description: '大模型根据提示词输出的内容',
      valueType: ModuleIOValueTypeEnum.string,
      type: FlowNodeOutputTypeEnum.source,
      targets: [],
    },
  ],
};
